
var Model = require("../types/Model.js");
var Fetch = require("fetch-ponyfill")({
	Promise: require("promise")
});
var fetch = Fetch.fetch;
var Platform = require("react-native").Platform;

// How frequently to check. 15 minutes
var interval_time = 15 * 60 * 1000;

/**
 * This model checks for changes in the version of the local content on Rackspace
 * @type {Model}
 */
module.exports = Model({
	name: "updaterefresher",
	init: init,
	uninit: uninit,
	_interval: null,
	start_checking: start_checking,
});

/**
 * Pushes initial version as the state, starts checking every hour
 */
function init() {
	var config = this.config;
	var version_string = config.version + "#" + config.build;
	this.push(version_string);
	this.start_checking();
}

/**
 * Clears checker
 */
function uninit() {
	var interval = this._interval;
	clearInterval(interval);
	this._interval = undefined;
}

/**
 * Starts checking for changes in the version
 */
function start_checking() {
	this._interval = setInterval(check_version.bind(this), interval_time);
}

/**
 * Checks the latest version of the content on Rackspace
 */
function check_version() {
	if(Platform && Platform.OS !== "web") return;
	return fetch("./VERSION.json")
		.then(function(response){
			return response.json();
		})
		.then(compare_version.bind(this))
		.catch(console.error.bind(console));
}

/**
 * Compares the local version with the latest one
 * If it's out of date, the window is reloaded
 * @param  {Object} data json-xhr result. Contains the `response` with the `version` and `build`
 */
function compare_version(response) {
	var version_string = response.version + "#" + response.build;
	var current_version = this.data;
	if (current_version !== version_string)
		this.emit("refresher:trigger:refresh");
}
